import $ from "jquery";
import Marionette from "marionette";
import MenuItemView from "./MenuItemView";


export default Marionette.CollectionView.extend("MenuItemsView", {
    childView: MenuItemView,
    tagName: "ul",
    className: "menu-items overview",

    events: {
        "click [mid]": "menuItemClick"
    },

    initialize(options) {
        options = options || {};
        this.menu = options.menu;
    },

    menuItemClick(e) {
        let $el = $(e.currentTarget);
        let mid = $el.attr("mid");
        let model = this.collection.get(mid);
        let $links = this.$el.find("li");

        $links.removeClass("active");
        $el.parents("li:first").addClass("active");

        this.trigger("go", model, e);
    },

    childViewOptions() {
        return { menu: this.menu };
    }
});
